/**
 * created by hezq on 2019-11-20
 *
 * description: 字符串工具类
 *
 */

import md5 from 'js-md5';

/**
 * description: 获取字符长度,中文算2个长度
 * @return {Number} 字符串长度
 * 
 * created by hezq on 2019-11-20
 *
 */
String.prototype.getLen = function() {
	return this.replace(/[\u0391-\uFFE5]/g, "**").length;
}

/**
 * description: 去掉字符串左侧的空格
 * @return {String} 新字符串
 * 
 * created by hezq on 2019-11-20
 *
 */
String.prototype.trimLeft = function() {
	return this.replace(/^\s*/, "");
}

/**
 * description: 去掉字符串右侧的空格
 * @return {String} 新字符串
 * 
 * created by hezq on 2019-11-20
 *
 */
String.prototype.trimRight = function() {
	return this.replace(/\s*$/, "");
}

/**
 * description: 去掉字符串左右侧的空格
 * @return {String} 新字符串
 * 
 * created by hezq on 2019-11-20
 *
 */
String.prototype.trim = function() {
	return this.trimRight().trimLeft();
}

/**
 * description: 去掉字符串中所有的空格
 * @return {String} 新字符串
 * 
 * created by hezq on 2019-11-20
 *
 */
String.prototype.trimAll = function() {
	return this.replace(/\s+/g, "");
}

/**
 * description: 去掉字符串中的tab和换行
 * @return {String} 新字符串
 * 
 * created by hezq on 2019-11-20
 *
 */
String.prototype.trimRN = function() {
	return this.replace(/[\r\n]/g, "");
}

/**
 * description: 用s2替换字符串中的匹配s1正则的
 * @param {RegExp | String} s1 匹配对象
 * @param {String} s2 替换对象
 * @return {String} 新字符串
 * 
 * created by hezq on 2019-11-20
 *
 */
String.prototype.replaceAll = function(s1, s2) {
	// 判断s1参数的数据类型
	let type = Object.prototype.toString.call(s1);

	// 字符串类型
	if (type === "[object String]") {
		let newStr = this;

		// 循环替换s1的内容
		while (newStr.indexOf(s1) > -1) {
			newStr = newStr.replace(s1, s2);
		}

		return newStr;
	}
	// 正则类型
	else if (type === "[object RegExp]") {
		return this.replace(new RegExp(s1, "gm"), s2);
	}
	// 其他类型,暂不处理
	else {
		return this;
	}

}

/**
 * description: 字符串反转
 * @return {String} 新字符串
 * 
 * created by hezq on 2019-11-20
 *
 */
String.prototype.reverse = function() {
	return this.split("").reverse().join("");
}

/**
 * description: 字符串是否包含某一个字符串
 * @param {String} searchStr 包含对象
 * @return {Boolean} true-包含 false-不包含
 * 
 * created by hezq on 2019-11-20
 *
 */
String.prototype.contains = function(searchStr) {
	return this.indexOf(searchStr) > -1;
}

/**
 * description: 字符串等值等类型判断
 * @return {Boolean} true-相等 false-不想等
 * 
 * created by hezq on 2019-11-20
 *
 */
String.prototype.equals = function(str) {
	return this === str;
}

/**
 * description: 字符串忽视大小写等值等类型判断
 * @return {Boolean} true-相等 false-不想等
 * 
 * created by hezq on 2019-11-20
 *
 */
String.prototype.equalsIgnoreCase = function(str) {
	return this.toLocaleLowerCase() === str.toLocaleLowerCase();
}

/**
 * description: 重复某个字符串
 * @param {Number} times 重复次数
 * @return {String} 重复之后的字符串
 * 
 * created by hezq on 2019-11-20
 *
 */
String.prototype.repeat = function(times) {
	let newStr = "";

	for (let i = 0; i < times; i++) {
		newStr += this;
	}

	return newStr;
}

/**
 * description: 字符串太长,截取部分,其余用...代替
 * @param {Number} len 保留数据的长度
 * @return {String} 新字符串
 * 
 * created by hezq on 2019-11-20
 *
 */
String.prototype.fitFormat = function(len) {
	// 如果长度没达到len,返回原字符串
	if (this.length <= len) {
		return this;
	}
	// 截取拼接处理
	let newStr = this.substr(0, len) + '...';

	return newStr;
}

/**
 * description: 通过身份证号获取生日/性别/年龄
 * @param {Number} type 1-生日 2-性别 3-年龄 
 * @return {String} 生日或性别货年龄
 * 
 * created by hezq on 2019-11-20
 *
 */
String.prototype.getSthByIDCard = function(type) {
	// 校验身份证号是否正确
	if (!this.isIDCard()) {
		return '身份证号错误';
	}
	// 15位身份证号
	if (this.length === 15) {
		// 获取生日
		if (type === 1) {
			let birth = '';

			birth = '19' + this.substring(6, 8) + "-" + this.substring(8, 10) + "-" + this.substring(10, 12);
			return birth;
		}
		// 获取性别
		else if (type === 2) {
			if (parseInt(this.substr(14, 1)) % 2 === 1) {
				return "男";
			} else {
				return "女";
			}
		}
		// 获取年龄
		else if (type === 3) {
			let myDate = new Date();
			let month = myDate.getMonth() + 1;
			let day = myDate.getDate();
			let age = myDate.getFullYear() - parseInt('19' + this.substring(6, 8)) - 1;

			if (this.substring(8, 10) < month || this.substring(8, 10) === month && this.substring(10, 12) <= day) {
				age++;
			}
			return age;
		}
	}
	// 18位身份证号
	else if (this.length === 18) {
		// 获取生日
		if (type === 1) {
			birth = this.substring(6, 10) + "-" + this.substring(10, 12) + "-" + this.substring(12, 14);
			return birth;
		}
		// 获取性别
		else if (type === 2) {
			if (parseInt(this.substr(16, 1)) % 2 === 1) {
				return "男";
			} else {
				return "女";
			}
		}
		// 获取年龄
		else if (type === 3) {
			let myDateTmp = new Date();
			let monthTmp = myDateTmp.getMonth() + 1;
			let dayTmp = myDateTmp.getDate();
			let ageTmp = myDateTmp.getFullYear() - this.substring(6, 10) - 1;

			if (this.substring(10, 12) < monthTmp || this.substring(10, 12) === monthTmp && this.substring(12, 14) <=
				dayTmp) {
				ageTmp++;
			}
			return ageTmp;
		}
	}
}

/**
 * description: 解决微服务表格字段和排序字段不一致的问题,例：createDate => create_date
 * @return {String} 转化后的字段名称
 * 
 * created by hezq on 2019-11-20
 *
 */
String.prototype.convertToDBColumn = function() {
	// 只能是字符串类型才转化
	if ("string" !== typeof this) {
		return '';
	}
	let arr = [];
	// 把字符串拆分成字符存储到arr中
	for (let i = 0; i < this.length; i++) {
		arr.push(this.charAt(i));
	}

	let newStr = "";

	// 循环转化
	arr.map(function(a) {
		if (/^[A-Z]+$/.test(a)) {
			a = '_' + a.toLowerCase();
		}
		newStr += a;
	});

	return newStr;
}

/**
 * description: 将字符串解析成Date类型日期
 * @param fmt 字符串格式，默认'yyyy-MM-dd'，支持如下：y、M、d、H、m、s、S，不支持w和q
 * @returns 解析后的Date类型日期
 * 
 * created by panjm on 2019-11-21
 * 
 */
String.prototype.toDate = function(fmt) {
	let str = this;
	fmt = fmt || 'yyyy-MM-dd';
	const obj = {
		y: 0,
		M: 1,
		d: 0,
		H: 0,
		h: 0,
		m: 0,
		s: 0,
		S: 0
	};

	fmt.replace(/([^yMdHmsS]*?)(([yMdHmsS])\3*)([^yMdHmsS]*?)/g, function(m, $1, $2, $3, $4) {
		str = str.replace(new RegExp($1 + '(\\d{' + $2.length + '})' + $4), function(_m, _$1) {
			obj[$3] = parseInt(_$1);
			return '';
		});
		return '';
	});
	obj.M--; // 月份是从0开始的，所以要减去1
	let date = new Date(obj.y, obj.M, obj.d, obj.H, obj.m, obj.s);

	if (obj.S !== 0) {
		date.setMilliseconds(obj.S);
	} // 如果设置了毫秒
	return date;
};

//------------------------------数字类-------------------------------------

/**
 * description: 判断是否为数字
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isNum = function() {
	let regu = /^[0-9]+.?[0-9]*$/;

	return regu.test(this);
};

/**
 * description: 判断是否为正数
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isPlusNum = function() {
	let regu = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;

	return regu.test(this);
};

/**
 * description: 判断是否为带指定小数位数的正数
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isPlusNumByDec = function(len) {
	let regu;

	if (len === 1) {
		regu = /^[+]{0,1}(\d+\.\d{1})$/;
	} else if (len === 2) {
		regu = /^[+]{0,1}(\d+\.\d{2})$/;
	} else if (len === 3) {
		regu = /^[+]{0,1}(\d+\.\d{3})$/;
	} else {
		return false;
	}
	return regu.test(this);
};

/**
 * description: 判断是否为非负数,带小数
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isPlusNumByDecHasZero = function(len) {
	let regu;

	if (len === 1) {
		regu = /^0|([+]{0,1}(\d+\.\d{1}))$/;
	} else if (len === 2) {
		regu = /^0|([+]{0,1}(\d+\.\d{2}))$/;
	} else if (len === 3) {
		regu = /^0|([+]{0,1}(\d+\.\d{3}))$/;
	} else {
		return false;
	}
	return regu.test(this);
};

/**
 * description: 判断是否为负数
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isMinusNum = function() {
	let regu = /^\-(\d+)$|^\-(\d+\.\d+)$/;

	return regu.test(this);
};

/**
 * description: 判断是否为带指定小数位数的负数
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isMinusNumByDec = function(len) {
	let regu;

	if (len === 1) {
		regu = /^\-(\d+\.\d{1})$/;
	} else if (len === 2) {
		regu = /^\-(\d+\.\d{2})$/;
	} else if (len === 3) {
		regu = /^\-(\d+\.\d{3})$/;
	} else {
		return false;
	}
	return regu.test(this);
};

/**
 * description: 判断是否为带指定小数位数的非正数
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isMinusNumByDecHasZero = function(len) {
	let regu;

	if (len === 1) {
		regu = /^0|(\-(\d+\.\d{1}))$/;
	} else if (len === 2) {
		regu = /^0|(\-(\d+\.\d{2}))$/;
	} else if (len === 3) {
		regu = /^0|(\-(\d+\.\d{3}))$/;
	} else {
		return false;
	}
	return regu.test(this);
};

/**
 * description: 判断是否为正整数
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isPositiveInt = function() {
	let regu = /^[+]{0,1}[1-9][0-9]*$/;

	return regu.test(this);
};

/**
 * description: 判断是否为非负整数,包含0
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isPositiveIntHasZero = function() {
	let regu = /^(0|[1-9]\d*)$/;

	return regu.test(this);
};

/**
 * description: 判断是否为负整数
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isNegativeInt = function() {
	let regu = /^\-[1-9][0-9]*$/;

	return regu.test(this);
};

/**
 * description: 判断是否为非正整数,包含0
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isNegativeIntHasZero = function() {
	let regu = /^(0|\-[1-9]\d*)$/;

	return regu.test(this);
};

//------------------------------字符类-------------------------------------

/**
 * description: 判断是否为中文
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isCChar = function() {
	let regu = /^[\u4e00-\u9fa5]{0,}$/;

	return regu.test(this);
};

/**
 * description: 判断是否为字母或者数字
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isLetterOrNum = function() {
	let regu = /^[A-Za-z0-9]+$/;

	return regu.test(this);
};

/**
 * description: 判断是否为字母和数字组合或者下划线
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isLetterAndNumOrLine = function() {
	let regu = /^(?![0-9]+$)(?![a-zA-Z]+$)([0-9A-Za-z_]+)$/;

	return regu.test(this);
};

/**
 * description: 判断是否为字母或者数字或者下划线
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isLetterOrNumOrLine = function() {
	let regu = /^[A-Za-z0-9_]+$/;

	return regu.test(this);
};

/**
 * description: 判断是否为字母或者数字或者下划线开头
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isFirstLetterOrNumOrLine = function() {
	let regu = /^[A-Za-z][A-Za-z0-9_]+$/;

	return regu.test(this);
};

/**
 * description: 判断是否为中文或字母或数字或下划线
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isCCharLetterOrNumOrLine = function() {
	let regu = /^[\u4E00-\u9FA5A-Za-z0-9_]+$/;

	return regu.test(this);
};

//------------------------------特殊类-------------------------------------

/**
 * description: 判断是否符合邮箱格式
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isEmail = function() {
	let regu = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;

	return regu.test(this);
};

/**
 * description: 判断是否符合域名格式
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isDomain = function() {
	let regu = /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/;

	return regu.test(this);
};

/**
 * description: 判断是否符合url格式,可带参数
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isUrl = function() {
	let regu =
		/^(?=^.{3,255}$)(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*([\?&]\w+=\w*)*$/;

	return regu.test(this);
};

/**
 * description: 判断是否符合手机号格式
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isMobile = function() {
	let regu = /^[1][3-9][0-9]{9}$/;

	return regu.test(this);
};

/**
 * description: 判断是否符合电话号码格式,不带-,注意需要携带区号
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isTel = function() {
	let regu = /^0(10|2[0-5789]|\d{3})\d{7,8}$/;

	return regu.test(this);
};

/**
 * description: 判断是否符合身份证格式
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isIDCard = function() {
	const city = {
		11: "北京",
		12: "天津",
		13: "河北",
		14: "山西",
		15: "内蒙古",
		21: "辽宁",
		22: "吉林",
		23: "黑龙江 ",
		31: "上海",
		32: "江苏",
		33: "浙江",
		34: "安徽",
		35: "福建",
		36: "江西",
		37: "山东",
		41: "河南",
		42: "湖北 ",
		43: "湖南",
		44: "广东",
		45: "广西",
		46: "海南",
		50: "重庆",
		51: "四川",
		52: "贵州",
		53: "云南",
		54: "西藏 ",
		61: "陕西",
		62: "甘肃",
		63: "青海",
		64: "宁夏",
		65: "新疆",
		71: "台湾",
		81: "香港",
		82: "澳门",
		91: "国外 "
	};
	let pass = true;
	let str = this;

	if (!str || !/^[1-9][0-9]{5}(19[0-9]{2}|200[0-9]|2010)(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])[0-9]{3}[0-9xX]$/i.test(
			str)) {
		pass = false;
	} else if (!city[str.substr(0, 2)]) {
		pass = false;
	} else {
		//18位身份证需要验证最后一位校验位
		if (str.length === 18) {
			str = str.split('');
			//∑(ai×Wi)(mod 11)
			//加权因子
			const factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
			//校验位
			const parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
			let sum = 0;
			let ai = 0;
			let wi = 0;

			for (let i = 0; i < 17; i++) {
				ai = str[i];
				wi = factor[i];
				sum += ai * wi;
			}
			let last = parity[sum % 11];

			if (last != str[17]) {
				pass = false;
			}
		}
	}
	return pass;
};

/**
 * description: 判断是否符合账号格式：字母开头，允许5-16字节，允许字母数字下划线
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isAccount = function() {
	let regu = /^[a-zA-Z][a-zA-Z0-9_]{4,15}$/;

	return regu.test(this);
};

/**
 * description: 判断是否符合密码格式：以字母开头，长度在6~18之间，只能包含字母、数字和下划线
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isLowPwd = function() {
	let regu = /^[a-zA-Z]\w{5,17}$/;

	return regu.test(this);
};

/**
 * description: 判断是否符合强密码格式: 必须包含大小写字母和数字的组合，不能使用特殊字符，长度在8-10之间
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isHighPwd = function() {
	let regu = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,10}$/;

	return regu.test(this);
};

/**
 * description: 判断是否符合时间格式: 时:分:秒
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isTime = function() {
	let regu = /^(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/;

	return regu.test(this);
};

/**
 * description: 判断是否符合日期格式: yyyy-mm-dd
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isDate = function() {
	let regu = /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/;

	return regu.test(this);
};

/**
 * description: 判断是否符合日期+时间格式: yyyy-mm-dd hh:mm:ss
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isDatetime = function() {
	let regu = /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/;

	return regu.test(this);
};

/**
 * description: 判断是否符合qq号格式
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isQq = function() {
	let regu = /^[1-9][0-9]{4,}$/;

	return regu.test(this);
};

/**
 * description: 判断是否符合邮编格式
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isPostcode = function() {
	let regu = /^[1-9]\d{5}(?!\d)$/;

	return regu.test(this);
};

/**
 * description: 判断是否符合IP地址格式
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isIp = function() {
	let regu = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/g; //匹配IP地址的正则表达式

	if (regu.test(this)) {
		if (RegExp.$1 < 256 && RegExp.$2 < 256 && RegExp.$3 < 256 && RegExp.$4 < 256) {
			return true;
		}
	}
	return false;
};

/**
 * description: 判断是否符合端口号格式
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isPort = function() {
	let regu = /^([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{4}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/;

	return regu.test(this);
};

/**
 * description: 判断是否符合金额格式
 * @return {Boolean} true-是 false-否
 * 
 * created by panjm on 2019-11-21
 *
 */
String.prototype.isAmt = function() {
	let regu = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;

	return regu.test(this);
};

let strs = {};

/**
 * description: 随机获取一种颜色
 * @return {String} 颜色值,例: #000000
 * 
 * created by hezq on 2019-11-20
 *
 */
strs.getRandomColor = function() {
	return '#' + ('00000' + (Math.random() * 0x1000000 << 0).toString(16)).substr(-6);
}

/**
 * description: 获取一个GUID
 * @return {String} GUID
 * 
 * created by hezq on 2019-11-20
 *
 */
strs.GUID = function() {
	// 获取一段随机数
	function s4() {
		return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
	}
	// 获取时间戳
	let t = new Date().getTime();

	// 加密返回
	return md5(s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4() + t);
}

export default strs;



// WEBPACK FOOTER //
// ./src/tools/str/index.js